__turbopack_context__.v({
  "topInfoContent": "VglJOG_topInfoContent",
  "topInfoText": "VglJOG_topInfoText",
});
